import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSocialFacebook = function IconSystemSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.125 23V12.979h3.26l.486-3.923h-3.746V6.558c0-1.135.306-1.903 1.873-1.903H17V1.152A27 27 0 0 0 14.094 1C11.214 1 9.25 2.823 9.25 6.17v2.886H6v3.923h3.25V23z"
  }));
};